export default __webpack_public_path__ + "static/media/100001.573f9e02.jpg";